import { Controller } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { FieldShell, type FieldComponentProps } from "./field-shell";

export function NumberField({ field, control, disabled }: FieldComponentProps) {
  if (field.kind !== "number") return null;
  return (
    <Controller
      name={field.name}
      control={control}
      render={({ field: f, fieldState }) => (
        <FieldShell
          id={f.name}
          label={field.label}
          required={field.required}
          helpText={field.helpText}
          error={fieldState.error?.message}
        >
          <Input
            id={f.name}
            type="number"
            // Render the raw user input so the cursor doesn't jump while
            // typing partial values like "12.". Zod coerces at validate.
            value={f.value == null ? "" : String(f.value)}
            onChange={(e) => f.onChange(e.target.value)}
            onBlur={f.onBlur}
            placeholder={field.placeholder}
            step={field.integer ? 1 : "any"}
            min={field.min}
            max={field.max}
            disabled={disabled}
            aria-invalid={!!fieldState.error}
          />
        </FieldShell>
      )}
    />
  );
}
